import { ATTENDANCE_SETTING_DEFAULTS } from '@/utils/attendanceSettings'

export const DEFAULT_WORK_TIME_UNIT = ATTENDANCE_SETTING_DEFAULTS.work_time_unit
export const DEFAULT_WORK_BASIC = ATTENDANCE_SETTING_DEFAULTS.work_basic

const DURATION_PATTERN = /^(\d{1,4}):([0-5]\d)$/

const parseDuration = value => {
  const text = value == null ? '' : String(value).trim()
  const match = DURATION_PATTERN.exec(text)
  if (!match) return null

  const hours = Number(match[1])
  const minutes = Number(match[2])
  const total = hours * 60 + minutes
  return Number.isSafeInteger(total) ? total : null
}

export const durationMinutes = (value, fallback = '') => {
  const parsed = parseDuration(value)
  if (parsed != null) return parsed
  return fallback ? parseDuration(fallback) : null
}

export const formatDurationMinutes = totalMinutes => {
  if (!Number.isSafeInteger(totalMinutes) || totalMinutes < 0) return ''
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

/**
 * 勤務表の日次時間外を計算する。
 *
 * 設定済みの切上げ単位は従来どおり従業員有利に切り上げる。旧契約企業の
 * NULL・空文字・00:00だけは1分単位へ寄せ、実績を丸めずNaNも作らない。
 */
export const calculateRosterOvertime = ({
  actualWork,
  basicWork,
  workTimeUnit,
  isHoliday = false
}) => {
  const actualMinutes = durationMinutes(actualWork)
  if (actualMinutes == null) return ''
  if (isHoliday) return formatDurationMinutes(actualMinutes)

  const basicMinutes = durationMinutes(basicWork, DEFAULT_WORK_BASIC)
  if (basicMinutes == null) return ''

  const overtimeMinutes = actualMinutes - basicMinutes
  if (overtimeMinutes <= 0) return ''

  let unitMinutes = durationMinutes(workTimeUnit, DEFAULT_WORK_TIME_UNIT)
  if (!Number.isSafeInteger(unitMinutes) || unitMinutes <= 0) {
    unitMinutes = durationMinutes(DEFAULT_WORK_TIME_UNIT)
  }

  return formatDurationMinutes(
    Math.ceil(overtimeMinutes / unitMinutes) * unitMinutes
  )
}
